<template>

  <div class="orderManager-sec default-bg">
		<normalBar 
		title="我的订单"
		path= '/Mine'
		></normalBar>

		<div class="order-tab">
			<span class="tab-item" :class="{'active': status==0}" @click="tabChange(0)">全部</span>
			<span class="tab-item" :class="{'active': status==1}" @click="tabChange(1)">待付款</span>
			<span class="tab-item" :class="{'active': status==2}" @click="tabChange(2)">待收货</span>
		</div>
		
		<div v-if="!loading">
			
		
		<div class="empty" v-if="orderList.length <= 0" v-cloak>
			<p>您还没有订单哦</p>
		</div>
		<div class="order-list-sec" :style="{ height: wrapperHeight + 'px' }" ref="wrapper" v-else>
			<mt-loadmore 
	  				:bottom-method="bottomTop" 
	  				@bottom-status-change="handleBottomChange" 
	  				:bottom-all-loaded="allLoaded"
	  				:autoFill = "false"
                	ref = "loadmore"
  				>

			<div class="bg-grey-sec">
				<div class="order-items" v-for="(item,itemIndex) in orderList">
					<div class="gift-sec order-sec"> 
						<div class="gift-header">
							<span>
								订单号：{{item.merchantId}}
							</span>
							
						</div>
						<div class="gift-body">
							<div class="gift-item" v-for="(proList,index) in item.merchantOrderDetailVos">
								<div>
									<div class="media" 
										v-if="proList.merchantOrderDetailGoodsVos.length > 1" 
										v-cloak
										@click="goOrderDetails(item.merchantId)"
									>
										<div class="media-left img-list">
											<div class="img-wrap">
												<img :src="!!order.imgUrl ? order.imgUrl : defaultIimgUrl " v-for="(order,orIndex) in proList.merchantOrderDetailGoodsVos">
											</div>
										</div>
										<div class="media-right">
											<div>
												<p>礼盒{{index+1}}</p>
												<p class="text-red">{{proList.userOrderStatusDesc}}</p>
											</div>
										</div>
									</div>

									<div class="media" 
										v-else 
										v-cloak 
										v-for="order in proList.merchantOrderDetailGoodsVos"
										@click="goOrderDetails(item.merchantId)"
									>
										<div class="media-left">
											<img :src="!!order.imgUrl ? order.imgUrl : defaultIimgUrl" alt="">
										</div>
										<div class="media-content" >
											<p class="m-title">
												<span>{{order.showGoodsName}} <span class="text-grey">{{order.skuProperty}}</span></span>
											</p>
											<p class="extraInfo">生日牌：{{order.chocoBoard}}</p>
											<p class="extraInfo">祝福贺卡：{{order.greetingCard}}</p>
											
										</div>

										<div class="media-right">
											<div>
												<p>礼盒{{index+1}}</p>
												<p class="text-red">{{proList.userOrderStatusDesc}}</p>
											</div>
										</div>
									</div>
									
									<div class="order-foot" v-if="proList.userOrderStatus == 15 || proList.userOrderStatus == 16">
										<button class="default-btn" type="button" @click="checkRefundDetails(proList.orderCode)">退款详情</button>
									</div>
									<div class="order-foot" v-if="proList.userOrderStatus == 7 || proList.userOrderStatus == 8">
										<button class="default-btn" type="button" @click="checkReceive(proList.orderCode,itemIndex,index)">确认收货</button>
									</div>
								</div>
							</div>
						</div>
						<div class="order-foot" v-if="item.userOrderStatus == 1">
							<span>
								<span>
									¥{{item.totalOrderAmount | filterPrice}}
								</span>
								<countDown
									:index = 'itemIndex'
									:timer = 'item.payTime'
									:payNo = 'item.payNo'
									v-on:timerOut = 'timerOuts'
								></countDown>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div slot="bottom" class="mint-loadmore-bottom">
                <span v-show="bottomStatus !== 'loading'" :class="{ 'rotate': bottomStatus === 'pull' }">上拉加载更多</span>
              	<span v-show="bottomStatus === 'loading'">Loading...</span>
            </div>
			</mt-loadmore>
		</div>
		</div>

	</div>

	


</template>


<script>
	import Vue from 'vue';
	import { Picker } from '@/js/mint-ui';
	import { Popup } from '@/js/mint-ui';
	import { Loadmore } from '@/js/mint-ui';
	Vue.component(Loadmore.name, Loadmore);
	Vue.component(Popup.name, Popup);
	Vue.component(Picker.name, Picker);



	import normalBar from '@/components/common/navbar/normalBar'
	import countDown from '@/components/order/countdown'


	import api from '@/api/api'

	import imgUrls from '../../assets/images/default-pro-small.png'
	
	import { mapState } from 'vuex'

	export default {
		data(){
			return {
				loading: true,
				status: 0,//状态 0 全部 1 待付款 2待收货
				// page: 0,
				// pageSize: 10,
				// totalPage: 0,
				// orderList: [],
				defaultIimgUrl:imgUrls,
				bottomStatus: '',
        		allLoaded: false,
        		wrapperHeight: '600'
			}

		},
		computed: {
			...mapState({
				orderList: state => state.orderState.orderList,
				totalPage: state => state.orderState.totalPage,
				page: state => state.orderState.page,
			})
		},
		components: {
			normalBar,
			countDown
		},
		watch:{
			page(val,oldVal){
				if(val > this.totalPage){
					this.allLoaded = true;
				}else {
					this.allLoaded = false;
				}
			}
		},
		destroyed(){
			this.$store.commit('resetOrderList')
		},
		mounted(){
			let self = this;
			
			self.init();
//			document.addEventListener("visibilitychange", function(){
//				// document.title = document.hidden ? "用户离开了" : "用户回来了";
//				if(!document.hidden){
////          location.reload()
//					self.$router.go();
//					// self.init();
//				}
//			});

		},
		methods:{
			init(){
				let self  =this;
				self.status = self.$route.params.status;

				this.getOrderList(this.status).then(function(){
					self.loading = false;
					self.$nextTick(function(){
						self.wrapperHeight = document.documentElement.clientHeight - self.$refs.wrapper.getBoundingClientRect().top;
					})

				});
			},
			getOrderList(){
				let self = this;
				return new Promise(function(resolve,reject){
						self.$store.dispatch('getOrderList',{
							merchantStatus: parseInt(self.status)
						}).then(function(){
							resolve();
						})

						// api.post('api/appclient/v2/order/list',{
						// 	status: parseInt(self.status),
						// 	pageNo: self.page+1,
						// 	pageSize: self.pageSize
						// },function(json){
						// 	let res = json.body.data;
						// 	self.page ++;
						// 	self.totalPage =  res.totalPage;
						// 	self.orderList = self.page <=1 ? res.itemList :  self.orderList.concat(res.itemList);	
						// 	resolve();				
						// },false)
				})
				
			},
			tabChange(type){

				this.status = type;
				this.$store.commit('resetOrderList');
				this.getOrderList();
				this.$router.push({
					path: '/orderManager/'+this.status
				})
			},
			bottomTop() {
				this.getOrderList();
		        this.$refs.loadmore.onBottomLoaded();
		    },
	        handleBottomChange(status) {
	            this.bottomStatus = status;
	        },
	        goOrderDetails(mchId){
	        	let self = this;
				this.$router.push({path: '/orderDetails/'+mchId,query: {status: self.status}})
	        },
	        checkRefundDetails(orderCode){
				this.$router.push({
					path: '/orderRefundDetails/'+orderCode
				})
	        },
	        checkCancel(orderId){
	        	this.$router.push({
					path: '/orderCancel/'+orderId
				})
	        },
	        checkReceive(orderCode,itemIndex,index){//确认收货
				this.$store.dispatch('checkReceive',{orderCode,itemIndex,index})	
	        },
	        timerOuts(index){
				
				this.$store.commit('ORDERCANCEL',index);
	        }
		}
	}



</script>


<style lang="scss">
	@import '../../assets/css/mixin';

  .orderManager-sec {
  }

  .empty {
		margin: pxToRem(100px) 0;
		text-align: center;
		color: #666;
	}

	.bg-grey-sec {
		padding-bottom:pxToRem(40px);
		background-color: #eee;
		
		&:first-of-type {
			.order-items {
				margin-top: pxToRem(40px);
			}
		}
	}
	.order-tab {
		display: flex;
		justify-content: space-around;
		background-color: #fff;
		.tab-item {
			display: inline-block;
			padding: pxToRem(25px) pxToRem(10px);

			&.active {
				color: #D4B675;
				border-bottom: 2px solid #D4B675;
			}
			
		}
	}
	.order-list-sec {
		.mint-loadmore {
			background-color: #eee;
		}

		.order-items {
			padding-left: pxToRem(50px);
			background-color: #fff;
		}
		
		.order-sec {
			background-color: #fff;
			.gift-header {
				padding: 0 pxToRem(50px) 0 0;
				text-align: center;
				line-height: pxToRem(66px);
				color: #030303;
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: pxToRem(110px);
			}

			.media{
				padding: pxToRem(34px) pxToRem(54px) pxToRem(34px) 0;
				border-top: 1px solid #eeeeee;

				.media-left {
					width: pxToRem(132px);
					height: pxToRem(132px);
				}

				.img-list {
					display: inline-flex;
					flex: 1;

					.img-wrap {
						width: 90%;
						white-space: nowrap;
						overflow: auto;
					}
					img {
						width: pxToRem(132px);
						height: pxToRem(132px);
						display: inline-block;
						&:not(:last-of-type){
							margin-right: pxToRem(20px);
						}
					}
				}
				
				.media-content {
					padding-top: 0;
					padding-left: pxToRem(20px);
				    overflow: hidden;
				    white-space: nowrap;
				    text-overflow: ellipsis;

				    .m-title {
				    	margin-bottom: pxToRem(10px);
				    	font-size: pxToRem(24px);
				    	padding-right: 0;

				    	.text-grey {
				    		margin-left: pxToRem(20px);
				    	}
				    }
				    &>div {
						width: 100%;
				    }

				    .extraInfo{
				    	color: #666;
				    	font-size: pxToRem(20px);
				    	white-space: normal;
				    	line-height: 1.5em;

				    }
				}

				.media-right {
					display: inline-flex;
				    align-items: center;
				    text-align: right;

				    .text-red {
				    	margin-top: pxToRem(10px);
				    }
				}
				
			}
		}

	}
	
	.order-foot {
		padding: pxToRem(20px) pxToRem(50px);
		border-top: 1px solid #eee;
		text-align: right;
	}
</style>


// WEBPACK FOOTER //
// orderManager.vue?09079ef0